"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_validator_1 = require("./base-validator");

var Validator =
/** @class */
function () {
  function Validator() {
    this.PhoneNumber = new base_validator_1.BaseEntityFieldValidator(9, 10, /^[0-9]{9,10}$/);
    this.MobileNumber = new base_validator_1.BaseEntityFieldValidator(10, 10, /^[0-9]{10}$/);
    this.Email = new base_validator_1.BaseEntityFieldValidator(3, 200, /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/);
    this.Password = new base_validator_1.BaseEntityFieldValidator(8, 16, /^(?!.* )(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\u005e\u0024\u002a\u002e\u005b\u005d\u007b\u007d\u0028\u0029\u003f\u0022\u0021\u0040\u0023\u0025\u0026\u002f\u005c\u002c\u003e\u003c\u0027\u003a\u003b\u007c\u005f\u007e\u0060]).{8,16}$/);
  }

  return Validator;
}();

exports.CommonValidator = new Validator();